const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const SLOTS = ["09:00 AM", "11:00 AM", "01:00 PM", "03:00 PM", "05:00 PM"];

export const AvailabilityGrid = ({ value = {}, onChange, testidPrefix = "avail" }) => {
  const toggle = (day, slot) => {
    const current = value[day] || [];
    const next = current.includes(slot)
      ? current.filter((s) => s !== slot)
      : [...current, slot];
    const updated = { ...value };
    if (next.length) updated[day] = SLOTS.filter((s) => next.includes(s));
    else delete updated[day];
    onChange(updated);
  };

  const toggleDay = (day) => {
    const updated = { ...value };
    if (value[day] && value[day].length) delete updated[day];
    else updated[day] = [...SLOTS];
    onChange(updated);
  };

  return (
    <div className="space-y-2">
      {WEEKDAYS.map((day) => {
        const active = (value[day] || []).length > 0;
        return (
          <div key={day} className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => toggleDay(day)}
              data-testid={`${testidPrefix}-day-${day}`}
              className={`w-14 shrink-0 text-xs font-semibold px-2 py-1.5 rounded-lg border transition-colors ${active ? "bg-primary text-primary-foreground border-primary" : "border-border text-muted-foreground hover:bg-secondary"}`}
            >
              {day}
            </button>
            <div className="flex flex-wrap gap-1.5">
              {SLOTS.map((slot) => {
                const on = (value[day] || []).includes(slot);
                return (
                  <button
                    key={slot}
                    type="button"
                    onClick={() => toggle(day, slot)}
                    data-testid={`${testidPrefix}-${day}-${slot}`}
                    className={`text-[11px] px-2.5 py-1 rounded-full border transition-colors ${on ? "bg-primary/90 text-primary-foreground border-primary" : "border-border text-muted-foreground hover:bg-secondary"}`}
                  >
                    {slot}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
      <p className="text-xs text-muted-foreground pt-1">Tap a day to toggle all slots, or pick individual slots. Empty day = unavailable.</p>
    </div>
  );
};
